import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Step1CompanyRegistration } from "./step1-company-registration/step1-company-registration";
import { Step2LicenseDetails } from "./step2-license-details/step2-license-details";
import { Step3CompanyInformation } from "./step3-company-information/step3-company-information";

@Component({
  selector: 'app-step2-company-details',
  imports: [CommonModule, Step1CompanyRegistration, Step2LicenseDetails, Step3CompanyInformation],
  templateUrl: './step2-company-details.html',
  styleUrl: './step2-company-details.css'
})
export class Step2CompanyDetails {
  @Input() data: any;
  @Input() onboardingStep!: number;
  @Input() onboardingSubStep!: number;
  @Output() dataChange = new EventEmitter<any>();
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  companyDetailsForm: any = {
    companyRegistration: {},
    licenseDetails: {},
    companyInformation: {}
  };

  constructor() {
  }

  onNextClick() {
    this.next.emit();
  }

  onPrevClick() {
    this.prev.emit();
  }
}
